<template>
    <div id="tdMainDiv">
        <div id="tdContentDiv">
            <div id="tdFilterDiv">
        <span class="tdFilterTitle">
          标题:
        </span>
                <el-input
                        placeholder="请输入标题搜索"
                        v-model="filterName"
                        class="input-with-select"
                        size="small"
                        style="width: 250px;"
                        clearable>
                    <el-button slot="append" icon="el-icon-search" @click="inputSearch"></el-button>
                </el-input>
                <span class="tdFilterTitle">
          申请时间:
        </span>
                <el-date-picker
                        v-model="dateValues"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        size="small">
                </el-date-picker>
                <span class="tdFilterTitle">
          状态:
        </span>
                <el-select v-model="statusType" placeholder="请选择流程状态" size="small" style="width: 90px;">
                    <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div id="tdTableDiv">
                <el-table
                        :data="tableData"
                        border
                        stripe
                        size="small"
                        :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                        style="width: 100%"
                        height="100%"
                >
                    <el-table-column
                            prop="title"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            label="标题"
                    ></el-table-column>
                    <el-table-column
                            prop="drafterName"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="180"
                            label="申请人"
                    ></el-table-column>
                    <el-table-column
                            prop="drafterOrgName"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="180"
                            label="部门"
                    ></el-table-column>
                    <el-table-column
                            prop="flowStatusName"
                            align="center"
                            :show-overflow-tooltip="true"
                            width="80"
                            label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.flowStatusName === '草稿' ? '未提交' : scope.row.flowStatusName }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="submitTime" align="center" width="125" label="申请日期"></el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="50">
                        <template slot-scope="scope">
                            <el-tooltip content="操作" placement="top">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-edit"
                                        @click="handleData(scope.row)"
                                        circle
                                        plain
                                ></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div id="tdPaginationDiv">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[15, 30, 50, 100]"
                        :page-size="rows"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </div>

        <div class="enptyDiaDiv">
            <el-dialog
                    closed="true"
                    closable="false"
                    :visible.sync="enptyDialogVisible"
                    @close="updateData"
                    width="0"
                    height="0"
            ></el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: "Copydo",
    data() {
        return {
            rows: 15,
            total: 0,
            currentPage: 1,
            tableData: [],
            keyword: '',
            dateValues: [],
            statusType: '',
            filterName: '',
            enptyDialogVisible:false,
            statusOptions: [{
                value: '',
                label: '全部'
            }, {
                value: '1',
                label: '未提交'
            }, {
                value: '2',
                label: '退回'
            }, {
                value: '3',
                label: '流转中'
            }],
        };
    },
    methods: {
        inputSearch() {
            this.keyword = this.filterName
            this.handleCurrentChange(1)
        },
        handleSizeChange(val) {
            this.rows = val;
            this.currentPage = 1;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getTableData();
        },
        updateData() {
            this.getTableData();
        },
        getTableData() {
            var submitFromTime = ''
            var submitToTime = ''

            if (this.dateValues && this.dateValues.length === 2 ) {
                submitFromTime = this.dateValues[0]
                submitToTime = this.dateValues[1]
            }

            let prjInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
            var partCode = "";
            if (prjInfo.mainSectionCode === null || prjInfo.mainSectionCode === "") {
                partCode = prjInfo.mainPrjCode;
            } else {
                partCode = prjInfo.mainSectionCode;
            }

            //因为计量的待办不需要这个参数，暂时注释
            var list = [];
            // var jp = {
            //   propName: "partCode",
            //   propValueLike: partCode
            // };
            // list.push(jp);

            const user = JSON.parse(localStorage.getItem("Admin-Data"));
            var params = {
                page: this.currentPage,
                rows: this.rows,
                userId: user.userId,
                jsonInstProps: JSON.stringify(list),
                bizTitle: this.keyword,
                status: this.statusType,
                'submitFromTime': submitFromTime,
                'submitToTime': submitToTime
            };

            this.$axios
                .post(
                    "/api/workflow/personalWork/getCopyDoList",
                    this.$qs.stringify(params)
                )
                .then(response => {
                    this.total = response.data.total;
                    if (response.data.rows != null && response.data.rows.length > 0) {
                        this.tableData = []
                        //过滤掉无效业务地址的数据
                        response.data.rows.filter(it=>{
                            if (!it.bizType.startsWith('Quality')){
                                if(it.doUrl != undefined && it.doUrl != null){
                                    this.tableData.push(it)
                                }
                            }else{
                                this.tableData.push(it)
                            }
                        })
                    } else {
                        this.tableData = [];
                    }
                })
                .catch(error => {
                    console.log("error:" + error.toString());
                });
        },
        handleData(data) {
            console.log(data);

            if (data.bizType.startsWith('Quality')) {
                if (data.flowStatus === 1) {
                    if (data.bizType.endsWith("inspect_") || data.bizType.endsWith("evaluate_")) {
                        window.open(
                            `http://${window.location.hostname}:${window.location.port}/experiment/online/office/${data.bizPk}`
                        )
                    } else {
                        let clientPath = "http://localhost:8686/MessageService/";
                        let url2 = `${clientPath}check`;
                        //未打开客户端
                        const user = JSON.parse(localStorage.getItem("Admin-Data"));
                        const data1 = JSON.stringify({
                            token: localStorage.getItem("Admin-Msg"),
                            FileId: data.bizPk,
                            UserId: user.userId,
                            CurrentApprovalStatus: 1
                        });
                        this.enptyDialogVisible = true;
                        this.$message.success("正在启动客户端，请稍候...");
                        this.$axios.get(`${clientPath}${data1}`).then(res => {
                            if (res.data === "true") {
                                this.$message.success("正在启动客户端，请稍候...");
                            } else {
                                this.$message.error("启动客户端失败");
                            }
                        })
                    }
                } else {
                    window.open(
                        `http://${window.location.hostname}:${window.location.port}/experiment/online/office/${data.bizPk}`
                    );
                }
            } else {
                if (data.doUrl === undefined || data.doUrl === null) {
                    this.$message.error("无效业务地址!");
                    return
                }
                if (data.doUrl.indexOf('?') !== -1) {
                    window.open(
                        `http://${window.location.hostname}:${window.location.port}${data.doUrl}&id=${data.bizPk}&bizPk=${data.bizPk}`
                    );
                } else {
                    window.open(
                        `http://${window.location.hostname}:${window.location.port}${data.doUrl}?id=${data.bizPk}&bizPk=${data.bizPk}`
                    );
                }
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    updated() {
        console.log("更新");
    },
    watch: {
        statusType(newVal) {
            this.handleCurrentChange(1)
        },
        dateValues(newVal) {
            this.handleCurrentChange(1)
        },
    }
};
</script>

<style>
    .enptyDiaDiv .el-dialog .el-dialog__headerbtn {
        visibility: hidden;
    }
    #tdMainDiv {
        height: 100%;
    }
    #tdContentDiv {
        height: 100%;
        background: white;
        padding: 0px 5px 5px 10px;
        box-sizing: border-box;
    }
    #tdFilterDiv {
        height: 45px;
        line-height: 45px;
    }
    #tdTableDiv {
        height: 100%;
        box-sizing: border-box;
        margin-top: -45px;
        padding-top: 45px;
        padding-bottom: 32px;
    }
    #tdPaginationDiv {
        height: 32px;
        background: #ecf5ff;
        text-align: left;
        margin-top: -32px;
    }
    .tdFilterTitle {
        width: 100px;
        text-align: right;
        font-size: 13px;
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Copydo.vue